import { CircularProgressBarCoreUniDriver } from './CircularProgressBarCore/CircularProgressBarCore.uni.driver';
import { CircularProgressBarSize, CircularProgressBarSkin } from './index';

export interface CircularProgressBarUniDriver extends CircularProgressBarCoreUniDriver {
  isErrorIconShown: () => Promise<boolean>;
  isSuccessIconShown: () => Promise<boolean>;
  getSize: () => Promise<CircularProgressBarSize>;
  getTooltipErrorMessage: () => Promise<any>;
  hasSkin: (skinName: CircularProgressBarSkin) => Promise<boolean>;
}
